/* ==========================================================================
   Account-not-set-up notice (PORTAL-198)
   Shown on the provider login and forgot-password pages so providers without
   an account know to look for an invite or request access. The wording is the
   same whether or not the email exists, so it doesn't reveal which emails are
   registered.
   ========================================================================== */

import { Link } from 'react-router-dom'
import { usePortal, usePortalSlug } from '@/context/PortalContext'

export interface AccountNotSetUpNoticeProps {
  className?: string
}

export function AccountNotSetUpNotice({ className = '' }: AccountNotSetUpNoticeProps) {
  const slug = usePortalSlug()
  const { config } = usePortal()

  // Only link to the request-access form when the landing page shows it;
  // otherwise the link would bounce back to login or land on a page without it.
  const canRequestAccess =
    !!config && config.landing_page_enabled && config.show_invite_form_on_landing_page

  return (
    <p className={`text-center text-sm text-charcoal/60 ${className}`}>
      If you haven&rsquo;t received an invite from your pharmacy, your account may not
      be set up yet. Check your email for an invite or{' '}
      {canRequestAccess ? (
        <Link
          to={`/rx/${slug}#request-access`}
          className="text-[var(--pharmacy-primary)] hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--pharmacy-secondary)] rounded"
        >
          request access
        </Link>
      ) : (
        'contact your pharmacy'
      )}
      .
    </p>
  )
}
